import Vue from 'vue'
import VueRouter from 'vue-router'
import loginStore from '@/store/modules/login'
import { getCurrentUserId } from '@/js/jwt-utils'
import { validateRouteRegistration } from '@/js/permission-catalog'
import {
  isAuthNavigationCurrent,
  shouldRetainPermissionRouteOnLoadError
} from '@/js/auth-redirect'
import store from '@/store'
import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'
import Bom from '@/views/Bom.vue'
import MonthBom from '@/views/MonthBom.vue'
import Item from '@/views/Item.vue'
import Quotation from '@/views/Quotation.vue'
import CustomerRepair from '@/views/CustomerRepair.vue'
import InstallationNotice from '@/views/InstallationNotice.vue'
import InstallationAcceptance from '@/views/InstallationAcceptance.vue'
import Customer from '@/views/Customer.vue'
import SerialNumber from '@/views/SerialNumber.vue'
import User from '@/views/User.vue'
import Point from '@/views/Point.vue'
import ItemGroup from '@/views/ItemGroup.vue'
import Resume from '@/views/Resume.vue'
import InitResume from '@/views/InitResume.vue'
import Fix from '@/views/Fix.vue'
import Repair from '@/views/Repair.vue'
import EngineerWork from '@/views/EngineerWork.vue'
import Month from '@/views/Month.vue'
import NewMonth from '@/views/NewMonth.vue'
import Settle from '@/views/Settle.vue'
import InitMonth from '@/views/InitMonth.vue'
import NewInitMonth from '@/views/NewInitMonth.vue'
import Discount from '@/views/Discount.vue'
import NewDiscount from '@/views/NewDiscount.vue'
import EngineerStock from '@/views/EngineerStock.vue'
import TpManager from '@/views/TpManager.vue'
import SpecialNeed from '@/views/SpecialNeed.vue'
import CheckExcel from '@/views/CheckExcel.vue'
import MonthQuotation from '@/views/MonthQuotation.vue'
import Overage from '@/views/Overage.vue'
import i18n from '@/i18n'
import PageChangeRecord from '@/views/PageChangeRecord.vue'
import UpdateCustomerRepair from '@/views/UpdateCustomerRepair.vue'
import AuthorizeMapping from '@/views/AuthorizeMapping.vue'
import InstallPosition from '@/views/InstallPosition.vue'
import CustomerLicensePlateMapping from '@/views/CustomerLicensePlateMapping.vue'
import CheckMonthExcelPay from '@/views/CheckMonthExcelPay.vue'
import TempStock from '@/views/TempStock.vue'
import ThrowSunlikeSale from '@/views/ThrowSunlikeSale.vue'
import TransferOrder from '@/views/TransferOrder.vue'

// EGKCRM-514 PR-2 Permission Management — 等 demo 風格 RolesView / UsersView 完成後再加對應 import

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'app_bar_title'
    }
  },
  {
    path: '/login',
    name: 'Login',
    components: {
      default: Home, // 預設路徑為HOME
      login: Login // <router-view name="login">
    },
    meta: {
      title: 'login_btn'
    }
  },
  {
    path: '/bom',
    name: 'Bom',
    component: Bom,
    meta: {
      title: 'app_basic_bom',
      requiresPermission: { resource: 'bom', action: 'view' }
    }
  },
  {
    path: '/month_bom',
    name: 'MonthBom',
    component: MonthBom,
    meta: {
      title: 'app_basic_month_bom',
      requiresPermission: { resource: 'month_bom', action: 'view' }
    }
  },
  {
    path: '/item',
    name: 'Item',
    component: Item,
    meta: {
      title: 'app_basic_item',
      requiresPermission: { resource: 'item', action: 'view' }
    }
  },
  {
    path: '/quotation',
    name: 'Quotation',
    component: Quotation,
    meta: {
      title: 'app_sales_quotation',
      requiresPermission: { resource: 'quotation', action: 'view' }
    }
  },
  {
    path: '/customer_repair',
    name: 'CustomerRepair',
    component: CustomerRepair,
    meta: {
      title: 'app_sales_contract',
      requiresPermission: { resource: 'customer_repair', action: 'view' }
    }
  },
  {
    path: '/update_customer_repair',
    name: 'UpdateCustomerRepair',
    component: UpdateCustomerRepair,
    meta: {
      title: 'app_sales_update_contract'
      // update_customer_repair 未 seed 至 resource catalog，不可加 requiresPermission（fail-closed 會永遠攔截）
    }
  },
  {
    path: '/notice',
    name: 'InstallationNotice',
    component: InstallationNotice,
    meta: {
      title: 'app_install_notice',
      requiresPermission: { resource: 'notice', action: 'view' }
    }
  },
  {
    path: '/acceptance',
    name: 'InstallationAcceptance',
    component: InstallationAcceptance,
    meta: {
      title: 'app_install_acceptance',
      requiresPermission: { resource: 'acceptance', action: 'view' }
    }
  },
  {
    path: '/customer',
    name: 'Customer',
    component: Customer,
    meta: {
      title: 'app_basic_consumer',
      requiresPermission: { resource: 'customer', action: 'view' }
    }

  },
  {
    path: '/serial_number',
    name: 'SerialNumber',
    component: SerialNumber,
    meta: {
      title: 'app_basic_product_id',
      requiresPermission: { resource: 'serial_number', action: 'view' }
    }
  },
  {
    path: '/user',
    name: 'User',
    component: User,
    meta: {
      title: 'user_tool_bar_title',
      requiresPermission: { resource: 'user', action: 'view' }
    }
  },
  {
    path: '/point',
    name: 'Point',
    component: Point,
    meta: {
      title: 'app_basic_point',
      requiresPermission: { resource: 'point', action: 'view' }
    }
  },
  {
    path: '/item_group',
    name: 'ItemGroup',
    component: ItemGroup,
    meta: {
      title: 'app_basic_item_group',
      requiresPermission: { resource: 'item_group', action: 'view' }
    }
  },
  {
    path: '/resume',
    name: 'Resume',
    component: Resume,
    meta: {
      title: 'app_repair_resume',
      requiresPermission: { resource: 'resume', action: 'view' }
    }
  },
  {
    path: '/init_resume',
    name: 'InitResume',
    component: InitResume,
    meta: {
      title: 'app_basic_init_resume',
      requiresPermission: { resource: 'init_resume', action: 'view' }
    }
  },
  {
    path: '/fix',
    name: 'Fix',
    component: Fix,
    meta: {
      title: 'app_repair_fix',
      requiresPermission: { resource: 'fix', action: 'view' }
    }
  },
  {
    // 行動端自主工單不顯示桌面導覽框架。
    path: '/mobile_fix',
    name: 'MobileFix',
    component: () => import(/* webpackChunkName: "mobile-quick-create" */ '@/views/MobileQuickCreateView.vue'),
    meta: {
      title: 'mobile_quick_create_title',
      requiresPermission: { resource: 'mobile_fix', action: 'view' },
      retainOnPermissionLoadError: true,
      hideDesktopChrome: true
    }
  },
  {
    path: '/repair',
    name: 'Repair',
    component: Repair,
    meta: {
      title: 'app_repair_repair',
      requiresPermission: { resource: 'repair', action: 'view' }
    }
  },
  {
    path: '/engineer_work',
    name: 'EngineerWork',
    component: EngineerWork,
    meta: {
      title: 'app_engineer_work',
      requiresPermission: { resource: 'engineer_work', action: 'view' }
    }
  },
  {
    path: '/month',
    name: 'Month',
    component: Month,
    meta: {
      title: 'app_month_month'
    }
  },
  {
    path: '/new_month',
    name: 'NewMonth',
    component: NewMonth,
    meta: {
      title: 'app_month_month',
      requiresPermission: { resource: 'new_month', action: 'view' }
    }
  },
  {
    path: '/settle',
    name: 'Settle',
    component: Settle,
    meta: {
      title: 'app_month_settle',
      requiresPermission: { resource: 'settle', action: 'view' }
    }
  },
  {
    path: '/init_month',
    name: 'InitMonth',
    component: InitMonth,
    meta: {
      title: 'app_month_init_month'
    }
  },
  {
    path: '/new_init_month',
    name: 'NewInitMonth',
    component: NewInitMonth,
    meta: {
      title: 'app_month_init_month',
      requiresPermission: { resource: 'new_init_month', action: 'view' }
    }
  },
  {
    path: '/discount',
    name: 'Discount',
    component: Discount,
    meta: {
      title: 'app_month_discount'
    }
  },
  {
    path: '/new_discount',
    name: 'NewDiscount',
    component: NewDiscount,
    meta: {
      title: 'app_month_discount',
      requiresPermission: { resource: 'new_discount', action: 'view' }
    }
  },
  {
    path: '/engineer_stock',
    name: 'EngineerStock',
    component: EngineerStock,
    meta: {
      title: 'engineer_stock_title',
      requiresPermission: { resource: 'engineer_stock', action: 'view' }
    }
  },
  {
    path: '/tp_manager',
    name: 'TpManager',
    component: TpManager,
    meta: {
      title: 'tp_manager_title',
      requiresPermission: { resource: 'tp_manager', action: 'view' }
    }
  },
  {
    path: '/special_need',
    name: 'SpecialNeed',
    component: SpecialNeed,
    meta: {
      title: 'special_need_title',
      requiresPermission: { resource: 'special_need', action: 'view' }
    }
  },
  {
    path: '/check_excel',
    name: 'CheckExcel',
    component: CheckExcel,
    meta: {
      title: 'check_excel_title',
      requiresPermission: { resource: 'check_excel', action: 'view' }
    }
  },
  {
    path: '/month_quotation',
    name: 'MonthQuotation',
    component: MonthQuotation,
    meta: {
      title: 'month_quotation_title',
      requiresPermission: { resource: 'month_quotation', action: 'view' }
    }
  },
  {
    path: '/overage',
    name: 'Overage',
    component: Overage,
    meta: {
      title: 'overage_title',
      requiresPermission: { resource: 'overage', action: 'view' }
    }
  },
  {
    path: '/page_change_record',
    name: 'PageChangeRecord',
    component: PageChangeRecord,
    meta: {
      title: 'page_change_record_title',
      requiresPermission: { resource: 'page_change_record', action: 'view' }
    }
  },
  {
    path: '/authorize_mapping',
    name: 'AuthorizeMapping',
    component: AuthorizeMapping,
    meta: {
      title: 'authorize_mapping_title',
      requiresPermission: { resource: 'authorize_mapping', action: 'view' }
    }
  },
  {
    path: '/install_position',
    name: 'InstallPosition',
    component: InstallPosition,
    meta: {
      title: 'install_position_title',
      requiresPermission: { resource: 'install_position', action: 'view' }
    }
  },
  {
    path: '/customer_license_plate_mapping',
    name: 'CustomerLicensePlateMapping',
    component: CustomerLicensePlateMapping,
    meta: {
      title: 'customer_license_plate_mapping_title',
      requiresPermission: { resource: 'customer_license_plate_mapping', action: 'view' }
    }
  },
  {
    path: '/check_month_excel_pay',
    name: 'CheckMonthExcelPay',
    component: CheckMonthExcelPay,
    meta: {
      title: 'check_month_excel_pay_title',
      requiresPermission: { resource: 'check_month_excel_pay', action: 'view' }
    }
  },
  {
    path: '/temp_stock',
    name: 'TempStock',
    component: TempStock,
    meta: {
      title: 'temp_stock_title',
      requiresPermission: { resource: 'temp_stock', action: 'view' }
    }
  },
  {
    path: '/throw_sunlike_sale',
    name: 'ThrowSunlikeSale',
    component: ThrowSunlikeSale,
    meta: {
      title: 'throw_sunlike_sale_title',
      requiresPermission: { resource: 'throw_sunlike_sale', action: 'view' }
    }
  },
  {
    path: '/transfer_order',
    name: 'TransferOrder',
    component: TransferOrder,
    meta: {
      title: 'transfer_order_title',
      requiresPermission: { resource: 'transfer_order', action: 'view' }
    }
  },
  // EGKCRM-514 PR-2 新權限管理頁（/permission/*）
  //
  // 權限階層：
  //   permission_module (menu)  → 控制 sidebar 整個「權限設定」分類是否顯示
  //   permission_users  (page)  → 可進入 /permission/users
  //   permission_roles  (page)  → 可進入 /permission/roles
  //   permission_resources (page) → 可進入 /permission/resources
  //
  // beforeEach 會依 meta.requiresPermission 檢查，若無該權限 → 跳回首頁
  {
    path: '/permission',
    redirect: '/permission/users'
  },
  {
    path: '/permission/users',
    name: 'PermissionUsers',
    component: () => import(/* webpackChunkName: "permission" */ '@/views/Permission/UsersView.vue'),
    meta: {
      title: 'permission_users_title',
      requiresPermission: { resource: 'permission_users', action: 'view' }
    }
  },
  {
    path: '/permission/roles',
    name: 'PermissionRoles',
    component: () => import(/* webpackChunkName: "permission" */ '@/views/Permission/RolesView.vue'),
    meta: {
      title: 'permission_roles_title',
      requiresPermission: { resource: 'permission_roles', action: 'view' }
    }
  },
  {
    path: '/permission/resources',
    name: 'PermissionResources',
    component: () => import(/* webpackChunkName: "permission" */ '@/views/Permission/ResourceSwitcher.vue'),
    meta: {
      title: 'permission_resources_title',
      requiresPermission: { resource: 'permission_resources', action: 'view' }
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => { // 判斷有無登入機制
  const pendingRoute = to
  router.authPendingRoute = pendingRoute
  let identity = window.localStorage.getItem('Jwt') // 拿取JWT

  if (!identity) { // identity=false執行下面
    loginStore.state.IsLogin = false
    if (to.path !== '/login') {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next() // 留在原網址
    }
    return
  }

  if (to.path !== '/login') {
    loginStore.state.IsLogin = true // 把原本v-if 打開
  }

  // EGKCRM-514 PR-2 權限載入策略（不再被 requiresPermission 包住）：
  //
  // sidebar 的權限選單用 $can('permission_module','view') 過濾，store 是 fail-closed
  // （未載入回 false），若只在 requiresPermission 路由 load，使用者一直停在舊業務頁面就永遠
  // 看不到權限選單入口 → 點不進去 → 永遠不會觸發 load（雞生蛋蛋生雞）。
  //
  // 分流策略：
  //   1. 非權限路由（如 /item_group）→ fire-and-forget，不 await。sidebar 是 reactive，
  //      load 完成後 visibleItems 自動 re-render 顯示權限選單，使用者導航體感無延遲。
  //   2. 權限路由（requiresPermission）→ 必須 await，否則 can() 在 loaded=false 時
  //      fail-closed 誤擋（直接打 /permission/users 網址會 race 到首頁）。
  //   3. token 解析錯誤 → 權限路由 fail-fast 重導首頁（貼齊 reviewer E-08 設計：
  //      避免停在「看起來正常」但 API 全 403 的管理頁），非權限路由 swallow。
  let loadPromise = Promise.resolve()
  let tokenParseFailed = false
  if (to.path !== '/login' && !store.state.permission.loaded) {
    try {
      const token = window.localStorage.getItem('Jwt')
      if (token) {
        const userId = getCurrentUserId()
        if (userId) {
          loadPromise = store.dispatch('permission/load', userId)
        } else {
          tokenParseFailed = true
        }
      }
    } catch (e) {
      console.error('permission token parse failed', e)
      tokenParseFailed = true
    }
  }

  // EGKCRM-514 PR-2 權限路由守衛：有 requiresPermission 才檢查具體權限
  if (to.meta && to.meta.requiresPermission) {
    if (tokenParseFailed) {
      next('/')
      return
    }
    await loadPromise
    if (!isAuthNavigationCurrent(router, pendingRoute)) {
      next(false)
      return
    }
    const permissionLoadError = store.state.permission.loadError
    if (shouldRetainPermissionRouteOnLoadError(to, permissionLoadError)) {
      next()
      return
    }
    const { resource, action } = to.meta.requiresPermission
    if (!store.getters['permission/can'](resource, action)) {
      console.warn(`[router] missing permission: ${resource}.${action} for ${to.path}`)
      // 交給 App.vue 的「無權限」snackbar 顯示（非阻塞，取代舊版 window.alert）
      store.commit('permission/setAccessDenied', { resource, action })
      if (from && from.name) {
        router.authPendingRoute = null
        next(false)
      } else {
        next('/')
      }
      return
    }
  }

  next()
})

router.afterEach((to) => {
  if (to.meta.title) {
    document.title = i18n.t(to.meta.title)
  }
  if (router.authPendingRoute && router.authPendingRoute.fullPath === to.fullPath) {
    router.authPendingRoute = null
  }
})

// 前端強制註冊驗證（dev-only warn）：對稱後端 PermissionRegistrationValidator，
// 掃 routes 缺 requiresPermission 且非顯式 public 者，提示開發者補登錄。
if (process.env.NODE_ENV !== 'production') {
  const missing = validateRouteRegistration(routes)
  if (missing.length) {
    console.warn('[權限註冊] 以下 route 缺 requiresPermission 且非顯式 public：', missing)
  }
}

export default router
